import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { CreateFormDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FORM = "CREATE_FORM";

const allowedRoles = [UserRole.Owner];

type CreateFormRequest = CreateFormDto;

const createForm = async (req: CreateFormRequest): Promise<string> => {
  const response = await formsApi.formsControllerCreateForm(req);

  return response.data;
};

export const useCreateForm = (
  user: UserProfileDto | null,
): {
  createForm: UseMutateFunction<string, Error, CreateFormRequest, unknown>;
  createFormAsync: UseMutateFunction<string, Error, CreateFormRequest, unknown>;
  createFormEnabled: boolean;
  isSuccessCreateForm: boolean;
  isPendingCreateForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS, ACTION_CREATE_FORM],
    mutationFn: enabled ? createForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORMS] });
    },
  });

  return {
    createForm: mutate,
    createFormAsync: mutateAsync,
    createFormEnabled: enabled,
    isSuccessCreateForm: isSuccess,
    isPendingCreateForm: isPending,
  };
};
